import { env } from './variables';

export const isRegistrationMode = () => {
  return env.REACT_APP_REGISTRATION_URL
    ? window.location.host === env.REACT_APP_REGISTRATION_URL
    : false;
};
